import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Share2 } from 'lucide-react';

interface ShareReportTileProps {
  onClick: () => void;
}

export function ShareReportTile({ onClick }: ShareReportTileProps) {
  return (
    <motion.button
      onClick={onClick}
      className="theme-card p-4 flex items-center justify-between group hover:bg-primary/5 transition-colors w-full"
      whileHover={{ scale: 1.01 }}
      whileTap={{ scale: 0.99 }}
    >
      <div className="flex items-center gap-3">
        <div className="relative">
          <FileText className="w-5 h-5 text-primary" />
          <div className="absolute inset-0 bg-primary/20 blur-xl rounded-full" />
        </div>
        <div className="text-left">
          <div className="font-medium">Share with Physician</div>
          <div className="text-sm text-muted-foreground">Generate detailed health report</div>
        </div>
      </div>
      <Share2 className="w-4 h-4 text-primary opacity-0 group-hover:opacity-100 transition-opacity" />
    </motion.button>
  );
}